import React from 'react';
import PropTypes from 'prop-types';


import * as monetaryConstants from '../monetaryConstants';

import {FormattedNumber} from 'react-intl';


function Price({currency, doShowCurrencySymbol, maximumFractionDigits, value}) {

    return (
        <span role={'price'}>
            <FormattedNumber
                maximumFractionDigits={maximumFractionDigits}
                currency={currency.code}
                currencyDisplay={doShowCurrencySymbol ? 'symbol' : 'code'}
                style={'currency'}
                value={value}
            />
        </span>
    );
}


Price.propTypes = {
    ...monetaryConstants.SHAPE_PRICE,
    maximumFractionDigits: PropTypes.number
};

Price.defaultProps = {
    currency: monetaryConstants.CURRENCY_EUR,
    doShowCurrencySymbol: false,
    maximumFractionDigits: 2
};


export default Price;
